/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 * pdfjs: https://github.com/mozilla/pdf.js/issues/10838#issuecomment-522634611
 */

require('../bootstrap');
require('../plugins');
require('../index');
require('./assets');
require('bootstrap-show-password');
import videojs from '!video.js';
window.videojs = videojs;
require('./assets/vendor/custom-videojs-translation/vi/vi');
require('video.js/dist/lang/en');
import { Canvas, Rect } from 'fabric';
require('./assets/vendor/fabric-history/fabric-history');
window.moment = require('moment');

import * as SimpleSwitch from "a-simple-switch";
require('jquery.waitforimages/dist/jquery.waitforimages.min');

SimpleSwitch.init();

import Chart from 'chart.js/auto';
window.Chart = Chart;
import ChartDataLabels from 'chartjs-plugin-datalabels';
window.ChartDataLabels = ChartDataLabels;

import Vue from 'vue';
window.Vue = Vue;
Vue.component('fill-in-the-blanks-answer-setup-component', require('./components/FillInTheBlanksAnswerSetup.vue').default);